export const logFacebookEvent = (eventName: string, eventParams: Record<string, any>) => {
  try {
    // console.log('Firing fb event => ', `FB_${eventName}`, eventParams);
    // Web implementation can be added here if needed
  } catch (error) {
    console.error(error);
  }
};
